import { IONICWrapper } from "./common";
import { ManageUsersConfigFallback, MyLoadsConfigFallback } from "./constants";
import { isPlatform } from "@ionic/react";

export const bucketNameExtractForCount = (name: string,filter?:boolean) => {
    let bucketName = "";
    switch (name?.toLowerCase()) {
        case "deliveredneedsppwk":
            bucketName = `deliveredNeedsPaperWork${filter && "Filter"}Count`
            break;
        case "deliveredwithppwk":
            bucketName = `deliveredWithPaperWork${filter && "Filter"}Count`
            break;
        case "intransit":
            bucketName = `inTransit${filter && "Filter"}Count`
            break;
        case "driverassigned":
            bucketName = `driverAssigned${filter && "Filter"}Count`
            break;
        case "carrierassigned":
            bucketName = `carrierAssigned${filter && "Filter"}Count`
            break;
        case "carriertendered":
            bucketName = `carrierTendered${filter && "Filter"}Count`
            break;
        default:
            break;
    }
    return bucketName
}
export const myLoadShowMore = (myLoadsMaxPageSize: number, bucketLength: number, bucketCount: number) => {
    const data = bucketLength <= 0 ? null : ((bucketCount - bucketLength) > myLoadsMaxPageSize ? myLoadsMaxPageSize : (bucketCount - bucketLength) > 0 ? (bucketCount - bucketLength) : null)
    return data
}
export const showMoreButtonVisiblityWithCount = (count: number, maxLoad: number, page: number) => ((count / maxLoad) > page + 1)

export const showMoreButtonVisiblity = (showMoreButtonVisiblityValue: string) => {
    const value = showMoreButtonVisiblityValue === "yes" ? true : false;
    return value
}
export const loadCountFormatter = (count:number) =>{
    const myLoadsMaxPageSize = FetchFromMyLoadConfig("PageSize");
    return !count ? "0" : (count > myLoadsMaxPageSize ? `${myLoadsMaxPageSize}+`: count)
} 
export const FetchFromMyLoadConfig = (type: string) => {
    const isMobile = isPlatform("mobile");
    const _config = IONICWrapper?.details?.keys?.configuration?.MyLoadsConfig || MyLoadsConfigFallback;
    if (type) {
        const Data = (_config[type] && _config[type][isMobile ? "Mobile" : "Web"]) || (MyLoadsConfigFallback[type] && MyLoadsConfigFallback[type][isMobile ? "Mobile" : "Web"]);
        return Data;
    }
    return null;
}

export const FetchFromManageUserConfig = (type: string) => {
    const _config = IONICWrapper?.details?.keys?.configuration?.ManageUsersConfig || ManageUsersConfigFallback;
    if (type) {
        const Data = (_config[type] && _config[type]["Web"]) || (ManageUsersConfigFallback[type] && ManageUsersConfigFallback[type]["Web"]);
        return Data;
    }
    return null;
}